import "./DDA.css";

const DownloadDoctorApp = () => {
  return (
    <div className="download-doctor-app-body">
      <h1 className="header-text">EHS (Doctors Application)</h1>
      <a href="/doctor-app/Doctor Application v1.0.6.apk" className="download-btn" download>
        Download
      </a>
      <p>Click the button above to download the EHS Doctors Application.</p>
    </div>
  );
};

export default DownloadDoctorApp;
